import { BaseService } from "@kiddocare-platform/portal-common/base";
import type { Edge, Job, Node, QueueCount, RedisInfo, Schedule, ScopeQueueCount } from "@kiddocare-platform/portal-common/platform";
export class PlatformOrbitService extends BaseService {

  public async GetFlow(): Promise<{
    nodes: Array<Node>,
    edges: Array<Edge>
  }> {
    try {
      const response = await this.AxiosInstance.get('/administrator/orbit/config/flow');
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async getRedisInfo(): Promise<RedisInfo> {
    try {
      const response = await this.AxiosInstance.get('/administrator/redis/info');
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async SaveView(idNode: bigint, data: any): Promise<Node> {
    try {
      const response = await this.AxiosInstance.put('/administrator/orbit/config/node/' + idNode + '/SaveView',
        data
      );
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async GetScopesInfo(): Promise<Array<ScopeQueueCount>> {
    try {
      const response = await this.AxiosInstance.get('/administrator/orbit/handler/scopes');
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }


  public async GetQueuesInfo(): Promise<Array<QueueCount>> {
    try {
      const response = await this.AxiosInstance.get('/administrator/orbit/handler/queues');
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async GetQueueInfo(name: string): Promise<QueueCount> {
    try {
      const response = await this.AxiosInstance.get('/administrator/orbit/handler/queue/' + name);
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async GetJobSchedulers(queueName: string): Promise<Array<Schedule>> {
    try {
      const response = await this.AxiosInstance.post('/administrator/orbit/handler/queue/' + queueName + '/schedulers', {
        start: 0,
        end: 1000,
        asc: true
      });
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async GetJobScheduler(queueName: string, jobId: string): Promise<Schedule> {
    try {
      const response = await this.AxiosInstance.get('/administrator/orbit/handler/queue/' + queueName + '/scheduler/' + jobId);
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async UpsertJobScheduler(queueName: string, jobId: string, repeatOpts: any, jobTemplate: any): Promise<Schedule> {
    try {
      const response = await this.AxiosInstance.put('/administrator/orbit/handler/queue/' + queueName + '/scheduler/' + jobId, {
        repeatOpts: repeatOpts,
        jobTemplate: jobTemplate
      });
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async GetJobs(queueName: string, types: Array<string>, start: number, end: number, asc: boolean): Promise<{
    jobs: Array<Job>,
    total: number
  }> {
    try {
      const response = await this.AxiosInstance.post('/administrator/orbit/handler/queue/' + queueName + '/jobs', {
        types: types,
        start: start,
        end: end,
        asc: asc
      });
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async PauseQueue(queueName: string): Promise<void> {
    try {
      await this.AxiosInstance.put('/administrator/orbit/handler/queue/' + queueName + '/pause');
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async ResumeQueue(queueName: string): Promise<void> {
    try {
      await this.AxiosInstance.put('/administrator/orbit/handler/queue/' + queueName + '/resume');
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async EmptyQueue(queueName: string): Promise<void> {
    try {
      await this.AxiosInstance.put('/administrator/orbit/handler/queue/' + queueName + '/empty');
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async AddJob(queueName: string, jobName: string, jobData: any, jobOpts: any): Promise<any> {
    try {
      const response = await this.AxiosInstance.post('/administrator/orbit/handler/queue/' + queueName + '/add', {
        name: jobName,
        data: jobData,
        options: jobOpts
      });
      return response.data.data;
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async RetryJob(queueName: string, jobId: string): Promise<void> {
    try {
      await this.AxiosInstance.put('/administrator/orbit/handler/queue/' + queueName + '/' + jobId + '/retry');
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async CleanJob(queueName: string, jobId: string): Promise<void> {
    try {
      await this.AxiosInstance.put('/administrator/orbit/handler/queue/' + queueName + '/' + jobId + '/clean');
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async PromoteJob(queueName: string, jobId: string): Promise<void> {
    try {
      await this.AxiosInstance.put('/administrator/orbit/handler/queue/' + queueName + '/' + jobId + '/promote');
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }

  public async UpdateJobData(queueName: string, jobId: string, data: any): Promise<void> {
    try {
      await this.AxiosInstance.patch('/administrator/orbit/handler/queue/' + queueName + '/' + jobId + '/update-data', data);
    }
    catch (error: any) {
      this.log.error(error);
      throw new Error(error);
    }
  }
}